/* eslint-disable react/react-in-jsx-scope */

import '@styles/normalize.scss';
import '@styles/global.scss';
import '@styles/animations.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'antd/lib/tooltip/style/index.css';
import 'antd/lib/grid/style/index.css';
import 'leaflet/dist/leaflet.css';
import 'react-image-lightbox/style.css';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/cs';

import App, { AppProps } from 'next/app';
import Head from 'next/head';
// DAYJS LOCALE
import dayjs from 'dayjs';

import { RouterHistoryProvider } from '@utils/router-history-provider';
import { polyfillScripts } from '@utils/polyfill-scripts';
import { persistUtm } from '@utils/utm-storage';
import { Session } from '@utils/session';

import { GridContext, gridContextDefaults } from '@atoms';

import { GTMProvider } from '@modules/providers/gtm';
import { MessagesProvider } from '@modules/providers/messages-provider';
import { GoogleOptimizeProvider } from '@modules/providers/google-optimize';
import { AuthContextProvider } from '@modules/base/auth';

import { ErrorBoundary } from './_error';

import 'dayjs/locale/cs';
dayjs.locale('cs');

import 'proxy-polyfill';

type Props = AppProps;

class CustomApp extends App<Props> {
  componentDidMount() {
    // STORE UTM PARAMS
    persistUtm();
  }

  head() {
    return (
      <Head>
        {/* --- VIEWPORT --- */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/* --- FAVICON --- */}
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={require('@public/static/favicon/apple-touch-icon.png')}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={require('@public/static/favicon/favicon-32x32.png')}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={require('@public/static/favicon/favicon-16x16.png')}
        />
        <link
          rel="mask-icon"
          href={require('@public/static/favicon/safari-pinned-tab.svg')}
          color="#1875f0"
        />
        <link
          rel="shortcut icon"
          href={require('@public/static/favicon/favicon.ico')}
        />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="theme-color" content="#ffffff" />
        {/* GOOGLE SEARCH CONSOLE META */}
        <meta
          name="google-site-verification"
          content="uv7oKehe-5aAx4_MhnpKPzSFt0GlbMgpHJ6BPMCAdMk"
        />
        {/* Facebook verification META */}
        <meta
          name="facebook-domain-verification"
          content="cuj11yk811bpvv41xa3odqjuke3trw"
        />
        {/* BABEL POLYFILL FOR IE */}
        {polyfillScripts}
      </Head>
    );
  }

  render() {
    const { Component, pageProps } = this.props;
    return (
      <ErrorBoundary>
        <GTMProvider>
          <GridContext.Provider value={gridContextDefaults}>
            <RouterHistoryProvider>
              <GoogleOptimizeProvider>
                <MessagesProvider>
                  <Session>
                    {/* HEAD */}
                    {this.head()}
                    {/* CHILDREN */}
                    <AuthContextProvider>
                      <Component {...pageProps} />
                    </AuthContextProvider>
                  </Session>
                </MessagesProvider>
              </GoogleOptimizeProvider>
            </RouterHistoryProvider>
          </GridContext.Provider>
        </GTMProvider>
      </ErrorBoundary>
    );
  }
}

export default CustomApp;
